<template>
    <div>
        <b-row>
            <b-col class="d-flex justify-content-between align-items-center">
                <slot name="header">
                    <text-header>Спецификация</text-header>
                </slot>
            </b-col>
        </b-row>
        <b-table id="my-table" :fields="fields" :items="items" class="table-atmo" details-td-class="py-1" show-empty small responsive>
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>
            <template #row-details="data">
                <template v-if="data.item.ktru">
                    <p><b>Рег.номер ТРУ:</b> {{ data.item.ktru.reg_number }}</p>
                    <p><b>Группа ТРУ:</b> {{ data.item.ktru.ktru_group_name }}</p>
                    <p><b>Наименование:</b> {{ data.item.ktru.name }}</p>
                    <p><b>Тип:</b> {{ data.item.ktru.type }}</p>
                    <p v-if="data.item.okpd"><b>Код ОКПД2:</b> {{ data.item.okpd ? data.item.okpd.code : '&mdash;' }}</p>
                    <p v-if="data.item.ktru.country_of_origin_name"><b>Страна происхождения:</b> {{ data.item.ktru.country_of_origin_name }}</p>
                    <p v-if="data.item.ktru.description"><b>Описание:</b> {{ data.item.ktru.description }}</p>
                    <p v-if="data.item.ktru.specs && data.item.ktru.specs.length > 0"><b>Характеристики:</b></p>
                    <ul v-if="data.item.ktru.specs && data.item.ktru.specs.length > 0">
                        <li v-for="(spec, key) in data.item.ktru.specs" :key="'spec' + key">
                            <span class="fw-600">{{ spec.name }}</span
                            >: {{ spec.value }}
                        </li>
                    </ul>
                </template>
                <template v-else>&mdash;</template>
            </template>
            <template #cell(specs)="data">
                <action-button-small :title="(data.detailsShowing ? 'Скрыть' : 'Показать') + ' характеристики'" :icon="data.detailsShowing ? 'eye-slash' : 'eye'" @click="data.toggleDetails" />
                {{ data.item.ktru.name }}
            </template>
            <template #cell(count)="data">
                {{ data.item.count }}
                <br />
                {{ data.item.local_symbol }}
            </template>
            <template #cell(price)="data">
                {{ $formatPrice(data.item.price) }}
                <br />
                {{ data.item.price_per_unit_wo_vat ? $formatPrice(data.item.price_per_unit_wo_vat) : '&mdash;' }}
            </template>
            <template #cell(vat)="data">
                {{ data.item.vat ? data.item.vat.title : '&mdash;' }}
            </template>
            <template #cell(cost)="data">
                {{ $formatPrice(roundToTwoDecimals(data.item.sum_with_vat)) }}
                <br />
                {{ data.item.sum_wo_vat ? $formatPrice(roundToTwoDecimals(data.item.sum_wo_vat)) : '&mdash;' }}
            </template>
            <template #empty>
                <div class="w-100 text-center">Не добавлено позиций спецификации</div>
            </template>
            <template #bottom-row>
                <b-td colspan="5" class="text-right py-1">
                    <span class="fw-600">Стоимость итого c НДС, руб.:</span>
                    <br />
                    <span class="fw-600">Стоимость итого без НДС, руб.:</span>
                </b-td>
                <b-td class="text-right text-nowrap py-1">
                    <span class="fw-600">{{ $formatPrice(roundToTwoDecimals(totalCost)) }}</span>
                    <br />
                    <span class="fw-600">{{ priceWoVat ? $formatPrice(roundToTwoDecimals(priceWoVat)) : '&mdash;' }}</span>
                </b-td>
            </template>
        </b-table>
    </div>
</template>

<script>
import roundToTwoDecimals from '@lib/js/src/misc/roundToTwoDecimals';

export default {
    name: 'form-row-specification-table-with-vat-view',
    props: {
        value: {
            type: Array,
            required: true
        },
        totalCost: {
            type: Number,
            required: true
        },
        priceWoVat: {}
    },
    data() {
        return {
            fields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-1', thClass: 'align-text-top py-1', thStyle: { width: '1px' } },
                { key: 'specs', label: 'Наименование товара (работ, услуг)', tdClass: 'align-text-top py-1', thClass: 'align-text-top text-nowrap py-1', thStyle: { minWidth: '400px' } },
                { key: 'count', label: 'Количество / Ед.изм', tdClass: 'align-text-top py-1 text-nowrap text-right', thClass: 'align-text-top py-1 text-right', thStyle: { width: '160px' } },
                { key: 'price', label: 'Цена за ед. с НДС / без НДС, руб.', tdClass: 'align-text-top py-1 text-nowrap text-right', thClass: 'align-text-top py-1 text-right', thStyle: { width: '160px' } },
                { key: 'vat', label: 'НДС, %', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'align-text-top py-1', thStyle: { width: '70px' } },
                { key: 'cost', label: 'Стоимость с НДС / без НДС, руб.', tdClass: 'align-text-top py-1 text-nowrap text-right', thClass: 'align-text-top py-1 text-right', thStyle: { width: '160px' } }
            ],
            showSpec: false
        };
    },
    methods: {
        roundToTwoDecimals
    },
    computed: {
        items: {
            get() {
                return this.value;
            }
        }
    }
};
</script>
